// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"ecdd8598","167":"3811696e","453":"e4b1867d","490":"63ba15f5","491":"db664ccf","500":"9d255f2d","634":"6eb59242","704":"5202b3d9","794":"331bfd4d","830":"7f9e6613"}[chunkId] + ".chunk.js";
};